var angular=window.angular,ngModule;
try {ngModule=angular.module(["doxy.templates"])}
catch(e){ngModule=angular.module("doxy.templates",[])}
var v1="<div class=\"modal-inner custom-modal custom-modal--medium\">\n<scheduling-widget hide=\"$hide()\" current-person=\"peopleAvailable.models[0]\" user=\"user\"></scheduling-widget>\n</div>\n";
var id1="/app/realtime/components/scheduling/scheduling-popup/scheduling-popup.modal.ngtemplate.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;